import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import React, { useCallback } from "react";
import TextFieldFormControl from "../../field/TextFieldFormControl/TextFieldFormControl";
import IntegerField from "../../base/IntegerField/IntegerField";
import CheckboxField from "../../base/CheckboxField/checkboxField";
import AutocompleteField from "../../field/AutocompleteField";

const SurveyScoreDetailsForm = React.memo((props) => {
  const { t } = useTranslation();
  
    const handleChangeRole = useCallback((name, value) => {
      let selectedRole = props.filteringData?.scores.find(rk => rk.id === value)
      
    
      if(props.isNew){
      props.setFormValue((prev) =>({...prev, ... selectedRole}))
      }
      
    }, [props.filteringData])

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
    >
      <Grid item xs={12}>
        <AutocompleteField
          name="hrscore"
          multiple={false} 
          isObjectOption={true}
          optionLabelKey={"hrscore_name"} 
          value={props.formValue.hrscore}
          options={props.filteringData?.scores}
          label={t("form.survey_score_details_form.score")}
          onChange={props.onChangeAutocompleteWithCallback(
            handleChangeRole
          )}
          required
        />
      </Grid>
    </Grid>
  );
});

SurveyScoreDetailsForm.propTypes = {
  formValue: PropTypes.object,
  filteringData : PropTypes.object
};

export default SurveyScoreDetailsForm;
